import {useEffect, useState} from "react";

import soundIcon from "../assets/images/sound-icon.svg";
import wrongAnswer from "../assets/images/wrong-icon.svg";
import correctAnswer from "../assets/images/correct.svg";

function QuizHearIt({question, next}) {
    const [selected, setSelected] = useState(null)
    const [sound, setSound] = useState(null)
    const [clearTimer, setClearTimer] = useState(null)

    const handle = {
        select: s => {
            if (clearTimer) return
            setSelected(s)
            setClearTimer(setTimeout(() => {
                setClearTimer(null)
                setSelected(null)
            }, 3000))
            if (question.id === s.id) next()
        }
    }

    useEffect(() => {
        const load = async () => {
            const {default: url} = await import(`../assets/audio/${question.name}-reg.m4a`)
            setSound(new Audio(url))
        }
        load().then()
    }, [question])

    return (
        <div className={"quiz-hear-it"}>
            <h2>Listen to the phrases and pick the correct meaning</h2>
            <div className={"quiz-message"}>
            {
                selected === null ? ""
                    : selected.id === question.id ? <div className={"correct"}><span><img src={correctAnswer} alt={"correct answer"}/><span>Correct answer. Good job!</span></span></div>
                        : <div className={"wrong"}><span><img src={wrongAnswer} alt={"wrong Answer"}/><span>Incorrect answer. Try again!</span></span></div>
            }
            </div>
            <div className={"question-panel"}>
                <div className={"question"}>
                    <span>Phrase {question.id}</span>
                    <button onClick={() => sound.play()}><img src={soundIcon} alt={"sound Icon"}/></button>
                </div>
                <ul className={"answers"}>
                    { question.answers.map(q => <li key={q.id} onClick={() => handle.select(q)}
                                                    className={selected !== q ? "" : q.id === question.id ? "correct" : "wrong"}>{q.text.en}</li>) }
                </ul>
            </div>
        </div>
    )
}

export default QuizHearIt
